export default __webpack_public_path__ + "static/img-team-5-008c8d2372d29f87598175563f668e52.png";